import { IconButton } from "@mui/material";
import StatusLayout from "components/Status";
import { set } from "date-fns";
import DatatableComponent from "helpers/DatatableComponent";
import DeleteDialog from "helpers/DeleteDialog";
import FormDialog from "helpers/FormDialog";
import { errorToast } from "helpers/Notification";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { currencyValues } from "store/helpers/common_functions";
import { mapDispatchToProps } from "store/helpers/mapDispatch";
import { mapStateToProps } from "store/helpers/mapState";


const PartnersAssignment = ({
    program,
    projectId,
    activityId,
    FetchDetails,
    info,
    onLoad
}) => {

  const [open, setOpen] = useState(0);
  const [value, setValue] = useState({});
  const [list, setList] = useState([]);
  const [id, setId] = useState();
  const [count, setCount] = useState(0);
  const [partners, setPartners] = useState([]);

    const [deleteOpen, setDeleteOpen] = useState(false);

  const onSuccess = () => setCount((v) => v + 1);
  const setValue0 = (name, val) => {
    if (!name) {
      return null;
    }

    setValue((v) => {
      v[name] = val;
      return { ...v };
    });
  };

  const query = program ? `programId=${program?.id}` : projectId ? `projectId=${projectId}` : activityId ? `activityId=${activityId}` : "";

    useEffect(async () => {
      const fetchPartners = await FetchDetails(`/api/partner/list`);
        if (fetchPartners.status) {
            setPartners(fetchPartners.data.data);
        }
    }, [program]);



  const columns = [
    {
      name: "partner",
      label: "Partner Name",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => (
          <span className="text-custom-blue text-xs ">{value?.name}</span>
        ),
      },
    },
    ...(!program ? [
    {
      name: "amount",
      label: "Amount",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => (
          <span className="text-[#A1A1A1] text-xs font-lighter">{value}</span>
        ),
      },
    },
    // {
    //   name: "receivedAmount",
    //   label: "Received Amount",
    //   options: {
    //     filter: true,
    //     sort: true,
    //     customBodyRender: (value) => (
    //       <span className="text-[#A1A1A1] text-xs font-lighter">{value}</span>
    //     ),
    //   },
    // },
    {
      name: "partnerType",
      label: "Partner Type",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => (
          <span className="text-[#A1A1A1] text-xs font-lighter">{value}</span>
        ),
      },
    },
    ] : [
      {
        name: "partner",
        label: "Address",
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (
            <span className="text-[#A1A1A1] text-xs font-lighter">{value?.address}</span>
          ),
        },
      },
      {
        name: "partner",
        label: "Representative",
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (
            <span className="text-[#A1A1A1] text-xs font-lighter">{value?.representative}</span>
          ),
        },
      },
    ]),
    {
      name: "status",
      label: "Status",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (status) => {
          return (
            <span style={{ fontSize: "0.85rem" }}>
              <StatusLayout status={status} />
            </span>
          );
        },
      },
    },
    {
      name: "id",
      label: "Action",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (v) => (
          <div className="flex items-center">

            <IconButton onClick={() => {
            //   history.push(`/admin/project/details/${v}`);
            }}>
              <img
                src={require("../../assets/icons/eye.svg").default}
                alt="Decorative SVG"
                className={
                  " mr-2 text-sm text-blueGray-300"
                }
              />
            </IconButton>

            <IconButton onClick={() => {
              setId(v);
              // set value
              setValue({
                partnerId: list.find((x) => x.id === v).partnerId,
                partnerType: list.find((x) => x.id === v).partnerType,
                amount: list.find((x) => x.id === v).amount,
                programId: list.find((x) => x.id === v).programId,
                currency: list.find((x) => x.id === v).currency,
              });
              setOpen(2);
            }
            }
            >
              <img
                src={require("../../assets/icons/pencil.svg").default}
                alt="Decorative SVG"
                className={
                  " mr-2 text-sm "
                }
                onClick={() => {
                  setId(v);
                  // set value
                  setValue({
                    partnerId: list.find((x) => x.id === v).partnerId,
                    partnerType: list.find((x) => x.id === v).partnerType,
                    amount: list.find((x) => x.id === v).amount,
                    programId: list.find((x) => x.id === v).programId,
                    currency: list.find((x) => x.id === v).currency,
                  });
                  setOpen(2);
                }
                }
              />
            </IconButton>
            <IconButton onClick={() => { setId(v); setDeleteOpen(true) }}>
              <img
                src={require("../../assets/icons/trash.svg").default}
                alt="Decorative SVG"
                className={
                  " mr-2 text-sm "
                }
              />
            </IconButton>

          </div>
        ),
      },
    },
  ];

  return (
    <div>
         <DeleteDialog 
                  open={deleteOpen} 
                  setOpen={() => setDeleteOpen(false)} 
                  onSuccess={onSuccess} 
                  url={`/api/partner/remove/assignment/${id}`} 
              />
        <FormDialog
          maxWidth={"md"}
          col={6}
          open={open > 0}
          onSuccess={() => {
            onSuccess();
            onLoad();
          }
          }
          setOpen={setOpen}
          url={open === 1 ? "/api/partner/assign" : `/api/partner/assign/update/${id}`}
          title={open === 1 ? "Assign Partner" : "Edit Assigned Partner"}
          fields={[

            {
                name: "partnerId",
                label: "Partner",
                value: value["partnerId"],
                values: partners.map((v) => {
                  return { label: v.name, value: v.id };
                }),
                  type: "select",
                  required: true,
                  col: 12,
                  setValue: (val) => setValue0("partnerId", val),
              },
           
            {
              name: "partnerType",
              label: "Partner Type",
              value: value["partnerType"],
              type: "radio",
              values: [
                { label: "Partially", value: "partial" },
                { label: "Full", value: "full" },

              ],
              required: true,
              col: 12,
              setValue: (val) => {
                if (val === "full") {
                  setValue0("amount", info?.project?.budget);
                } else {
                  setValue0("amount", 0);
                }
                setValue0("partnerType", val);

              }

            },
            {
              name: "amount",
              label: "Amount",
              value: value["amount"],
              hidden: value["partnerType"] === "partial",
              type: value["partnerType"] === "full" ? "text" : "number",
              isNumber: true,
              disabled: value["partnerType"] === "full",
              setValue: (val) => {
                setValue0("amount", val);
              },
            },
            // {
            //   name: "receivedAmount",
            //   label: "Received Amount",
            //   value: value["receivedAmount"],
            //   type:"number",
            //   isNumber: true,
            //   setValue: (val) => {
            //     setValue0("receivedAmount", val);
            //   },
            // },
        
            {
              name: program ? "programId" : activityId?  "activityId"  : "projectId", 
              label: "Program",
              value: program?.id ?? activityId ?? projectId,
              required: false,
              type: "text",
              hidden: true,
              setValue: (val) => setValue0(
                program ? "programId" : activityId?  "activityId"  : "projectId",
                val
              )
            },

            {
              name: "currency",
              label: "Currency",
              value: value["currency"],
              type: "select",
              values: currencyValues,
              // required: true,
              setValue: (val) => setValue0("currency", val),

            },
          ]}
        />
        
          <DatatableComponent
onAddNew={() => {
  const partner = list.find((x) => x.partnerType === "full");
  if (partner) {
   errorToast("You can not add more than one partner with full assignment");
    return;
  }

  setValue0("currency", "rwf");
  setValue0("partnerType", "partial");
  setValue0("amount", 0);

  setOpen(1)
}}
processData={(data) => {
  setList(data?.data);
  return data;
}}
onRowSelectionChange={(list) => {
  
 }}
search={false}
viewColumns={false}
elevation={1}
pdf={false}
excel={false}
columns={columns}
url={`/api/partner/assigned?&count=${count}&${query}`}
/>
    </div>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(PartnersAssignment);